export default __webpack_public_path__ + "static/media/BedBedSeat.67da70e5.svg";